const PG_AP_START_MAKING_CONTENT = {
  url: "https://amzscout.idevaffiliate.com",
  text: "Join AMZScout Affiliate Program Now",
  category: "AffiliateProgramLP",
}
export default PG_AP_START_MAKING_CONTENT
